import { Trans } from 'react-i18next';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { CompetitionManagerRemovedNotificationData } from './interfaces';

const isCompetitionManagerRemovedPayload = (
  payload: unknown
): payload is CompetitionManagerRemovedNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload && typeof payload.competitionName === 'string'
  );
};

export const competitionManagerRemovedPresenter: NotificationPresenter<CompetitionManagerRemovedNotificationData> =
  {
    type: 'competition-manager-removed',
    icon: EmojiEventsIcon,
    badgeIcon: GroupRemoveIcon,
    isPayload: isCompetitionManagerRemovedPayload,
    label: (payload, t) =>
      t('notifications:types.competition-manager-removed', {
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.competition-manager-removed"
        values={{
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return ROUTES.portal.competitions.details(payload.competitionSlug);
    },
  };
